var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gov_office") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gov_Office",
    "data-name": "Gov Office"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.64,
    y: 51.11,
    width: 56.71,
    height: 4.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.04,
    y: 74.94,
    width: 93.92,
    height: 4.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.04,
    y: 106.35,
    width: 93.92,
    height: 4.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.35,
    y: 55.26,
    width: 51.3,
    height: 19.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.53 79.09 89.2 79.09 77.1 79.09 70.78 79.09 58.68 79.09 52.36 79.09 40.26 79.09 33.93 79.09 26.35 79.09 21.83 79.09 21.83 106.35 33.93 106.35 33.93 86.3 40.26 86.3 40.26 106.35 52.36 106.35 52.36 86.3 58.68 86.3 58.68 106.35 70.78 106.35 70.78 86.3 77.1 86.3 77.1 106.35 89.2 106.35 89.2 86.3 95.53 86.3 95.53 106.35 107.63 106.35 107.63 86.3 107.63 79.09 95.53 79.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.16,51.2a17.25,17.25,0,0,0-34.5,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.56,
    y: 19.5,
    width: 1.44,
    height: 14.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "65 19.5 78.64 19.5 78.64 28.35 65 28.35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovOffice);
export default __webpack_public_path__ + "static/media/gov_office.9ac36f652039c7dec11ad33e7de8f81e.svg";
export { ForwardRef as ReactComponent };